<template>
  <div>
    <v-row justify="center" align="center">
      <v-col cols="12" sm="12">
        <v-banner icon="edit">
          Edit User
          <template v-slot:actions>
            <v-btn text color="blue darken-2" exact @click="$router.go(-1)">
              <v-icon left>arrow_back</v-icon>Back
            </v-btn>
          </template>
        </v-banner>
      </v-col>
      <v-col cols="12" md="6" sm="12">
        <v-form v-model="accountUserForm" ref="accountEdit" @submit.prevent>
          <v-text-field
            v-model="accountUserName"
            outlined
            prepend-inner-icon="account_box"
            :rules="[required('Full Name')]"
            label=" Full Name"
          />

          <v-text-field
            v-model="accountEmail"
            outlined
            label="Email address"
            name="email"
            prepend-inner-icon="mdi-email"
            type="email"
            :rules="[required('Email'), isEmail]"
            color="blue darken-2"
          />

          <v-btn
            block
            outlined
            type="submit"
            color="blue darken-2"
            :disabled="!accountUserForm"
            :loading="updateDetailsLoading"
            @click.stop="updateAccountUserEmail()"
          >
            Update
          </v-btn>
        </v-form>
      </v-col>
      <!-- <v-col cols="12" md="10" sm="12" v-else>
        <v-stepper
          v-model="currentStep"
          class="elevation-0"
          style="background-color: var(--v-background-base)"
        >
          <v-stepper-header>
            <v-stepper-step :complete="currentStep > 1" step="1"
              >User Information</v-stepper-step
            >
            <v-divider></v-divider>
            <v-stepper-step step="2">Delivery Information</v-stepper-step>
          </v-stepper-header>
          <v-stepper-items>
            <v-card-text style="text-align: end" class="py-0">
              <v-btn
                v-if="currentStep != 1"
                color="primary"
                text
                @click="currentStep--"
              >
                <v-icon left>mdi-keyboard-backspace</v-icon> Previous
              </v-btn>
            </v-card-text>
            <v-stepper-content step="1">
              <UserInfoForm
                :userDetails="userInfo"
                :error="userInfoError"
                :errorMessage="userInfoErrorMessage"
                @valid-user-info="nextStep"
              ></UserInfoForm>
            </v-stepper-content>
            <v-stepper-content step="2">
              <DeliveryInfoForm
                :deliveryAddress="deliveryInfo"
                :error="error"
                :errorMessage="errorMessage"
                :onRegister="updateDetails"
              ></DeliveryInfoForm>
            </v-stepper-content>
          </v-stepper-items>
        </v-stepper>
      </v-col> -->
    </v-row>
  </div>
</template>
<script>
import UserInfoForm from "@/components/auth/UserInfoForm.vue";
import DeliveryInfoForm from "@/components/auth/DeliveryInfoForm.vue";
import { mapGetter, mapGetters, mapActions } from "vuex";
import checkEmail from "@/util/validation/email.js";
export default {
  name: "ChangeUserDetails",
  components: {
    //UserInfoForm,
    //DeliveryInfoForm,
  },
  data: () => {
    return {
      userInfoError: "",
      error: "",
      errorMessage: "",
      userInfoErrorMessage: "",
      currentStep: 1,
      accountUserForm: false,
      required(fieldName) {
        return (v) => (v && v.length > 0) || `${fieldName} Required`;
      },
      isEmail: (val) => {
        return checkEmail(val);
      },
      accountUserName: "",
      accountEmail: "",
      updateDetailsLoading: false,
    };
  },
  computed: {
    ...mapGetters([
      "retrieveUser",
      "retrieveCustomerAddress",
      "retrieveCustomer",
    ]),
    userInfo() {
      if (this.retrieveCustomerAddress) {
        return {
          userName: this.retrieveCustomerAddress.name,
          email: this.retrieveUser.email_address,
          telephone: this.retrieveCustomerAddress.telephone_no,
        };
      }
      return {
        userName: "",
        email: "",
        telephone: "",
      };
    },
    deliveryInfo() {
      if (this.retrieveCustomerAddress) {
        return {
          addressLine1: this.retrieveCustomerAddress.address_line_1,
          addressLine2: this.retrieveCustomerAddress.address_line_2,
          addressLine3: this.retrieveCustomerAddress.address_line_3,
          addressLine4: this.retrieveCustomerAddress.address_line_4,
          postcode: this.retrieveCustomerAddress.postcode,
        };
      }
      return {
        addressLine1: "",
        addressLine2: "",
        addressLine3: "",
        addressLine4: "",
        postcode: "",
      };
    },
    isAccountCustomerEditing() {
      if (this.retrieveCustomer != 'no_customers') {
        if (
          this.retrieveCustomer.customer.delivery_account_no == "3" ||
          this.retrieveCustomer.customer.delivery_account_no == "1"
        ) {
          return false;
        }
        return true;
      }
      return false;
    },
  },
  methods: {
    ...mapActions(["updateUserDetails", "getCustomer", "setSnackbar"]),

    nextStep() {
      this.currentStep = this.currentStep + 1;
    },

    previousStep() {
      this.currentStep = this.currentStep - 1;
    },

    updateDetails() {
      this.error = false;
      this.errorMessage = "";
      const rec = Object.assign(
        {},
        { userId: this.retrieveUser.userNum },
        { sessionKey: this.retrieveUser.sessionKey },
        { userName: this.userInfo.userName.trim() },
        { email_address: this.userInfo.email.trim() },
        { telephone: this.userInfo.telephone.trim() },
        { address_line_1: this.deliveryInfo.addressLine1.trim() },
        { address_line_2: this.deliveryInfo.addressLine2.trim() },
        { address_line_3: this.deliveryInfo.addressLine3.trim() },
        { address_line_4: this.deliveryInfo.addressLine4.trim() },
        { postcode: this.deliveryInfo.postcode.trim() }
      );
      this.updateUserDetails(rec)
        .then((response) => {
          if (response.success == true) {
            console.log("Fetch Customer Now");
            if (this.$store.getters.retrieveUser.account_type == "C1") {
              this.getCustomer()
              .then((response) => {
                if (response.success == true) {
                  console.log("Redirect to Account Page");
                  this.previousStep();
                  this.setSnackbar({ text: "Details Updated Successfully" });
                  this.$router.push({ name: "UserAccount" });
                } else {
                  this.setSnackbar({
                    text: "Error Loading Customer",
                    color: "error",
                  });
                  console.log("Error Loadig Customer");
                }
              })
              .catch((er) => {
                console.log(er);
              });
              
            } else {
              this.previousStep();
              this.setSnackbar({ text: "Details Updated Successfully" });
              this.$router.push({ name: "UserAccount" });
            }
            
          } else {
            this.error = true;
            this.errorMessage = response.message;
            this.setSnackbar({ text: response.message, color: "error" });
            console.log("Error Updating User");
          }
        })
        .catch((er) => {
          console.log(er);
        });
    },

    async updateAccountUserEmail() {
      this.updateDetailsLoading = true;

      const rec = {
        userId: this.retrieveUser.userNum,
        sessionKey: this.retrieveUser.sessionKey,
        email_address: this.accountEmail.trim(),
        userName: this.accountUserName.trim(),
      };

      let response = await this.updateUserDetails(rec).catch((er) => {
        console.log(er);
        this.updateDetailsLoading = false;
      });

      if (response.success == true) {
        console.log("Fetch Customer Now");
        if (this.$store.getters.retrieveUser.account_type == "C1") {
          this.getCustomer()
          .then((response) => {
            if (response.success == true) {
              console.log("Redirect to Account Page");
              this.setSnackbar({ text: "Details Updated Successfully" });
              this.$router.push({ name: "UserAccount" });
            } else {
              this.setSnackbar({
                text: "Error Loading Customer",
                color: "error",
              });
              console.log("Error Loadig Customer");
            }
          })
          .catch((er) => {
            console.log(er);
          });

        } else  {
          console.log("Redirect to Account Page");
          this.setSnackbar({ text: "Details Updated Successfully" });
          this.$router.push({ name: "UserAccount" });
        }
        
      } else {
        this.setSnackbar({ text: response.message, color: "error" });
        console.log("Error Updating User");
      }

      this.updateDetailsLoading = false;
    },
  },

  activated() {
    this.accountUserName = this.retrieveUser.username;
    this.accountEmail = this.retrieveUser.email_address;
  },
};
</script>